import { configureStore, Reducer } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import appReducer from './features/app/appSlice';
import authReducer from './features/auth/authSlice';
import leadsReducer from './features/leads/leadsSlice';
import adReducer from './features/ads/adsSlice';
import marketReducer from './features/markets/marketsSlice';
import campaignReducer from './features/campaigns/campaignsSlice';

const createPersistedReducer = (
  key: string,
  whitelist: string[],
  reducer: Reducer,
) =>
  persistReducer(
    {
      key,
      version: 1,
      storage,
      whitelist,
    },
    reducer,
  );

const persistedAuthReducer = createPersistedReducer(
  'auth',
  ['isAuthenticated', 'user', 'accessToken'],
  authReducer,
);
const persistedLeadsReducer = createPersistedReducer(
  'leads',
  ['quizResult', 'matchedLeads'],
  leadsReducer,
);
const persistedCampaignsReducer = createPersistedReducer(
  'campaigns',
  ['campaignObjective', 'campaigns', 'pricingConfig'],
  campaignReducer,
);

const store = configureStore({
  reducer: {
    app: appReducer,
    auth: persistedAuthReducer,
    leads: persistedLeadsReducer,
    ads: adReducer,
    markets: marketReducer,
    campaigns: persistedCampaignsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
